export default __webpack_public_path__ + "static/media/center-bg.da95036b.jpg";